import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {BorrowerPhoneNumberVerificationComponent} from './borrower-phone-number-verification.component';

const routes: Routes = [{
    path: '',
    component: BorrowerPhoneNumberVerificationComponent
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class BorrowerPhoneNumberVerificationRoutingModule {
}
